import { DefaultInstructions } from './DefaultInstructions';
import { DrchronoInstructions } from './DrchronoInstructions';
import { ElationInstructions } from './ElationInstructions';
import { NextGenInstructions } from './NextGenInstructions';
import { NotSupportedInstructions } from './NotSupportedInstructions';
import type { Ehr } from '../../../types';
import { isValidEhr } from '../../../utils';

export type EhrCredentials = Record<string, string>;

export interface EhrIntegrationFormProps {
  /**
   * Class name for additional styling
   */
  className?: string;
  /**
   * The EHR type to integrate with
   */
  ehrType: Ehr;
  /**
   * The practice name
   */
  practiceName: string;
  /**
   * Whether the integration is completed
   */
  isCompleted?: boolean;
  /**
   * Callback when form is submitted with credentials
   */
  onSubmit?: (credentials: EhrCredentials) => void;
  /**
   * Whether the submit action is loading
   */
  isSubmitLoading?: boolean;
  /**
   * Whether the form has been successfully submitted
   */
  isSubmitted?: boolean;
  /**
   * Source context for analytics tracking (e.g., 'settingsPage', 'onboardingFlow')
   */
  source?: string;
}

/**
 * Form component for EHR integration with credentials input and actions.
 * Routes to the appropriate subcomponent based on EHR type.
 */
export const EhrIntegrationForm = (props: EhrIntegrationFormProps) => {
  const { ehrType } = props;

  if (!isValidEhr(ehrType)) {
    return <NotSupportedInstructions {...props} />;
  }

  switch (ehrType) {
    case 'drchrono':
      return <DrchronoInstructions {...props} />;
    case 'elation':
      return <ElationInstructions {...props} />;
    case 'next_gen':
      return <NextGenInstructions {...props} />;
    default:
      return <DefaultInstructions {...props} />;
  }
};

export default EhrIntegrationForm;
